import React from 'react';

const LoadingPip = React.createClass({
    propTypes: {
        pipId: React.PropTypes.number.isRequired,
    },

    render() {
        let pipId = 'pip' + this.props.pipId;
        return(
            <div id={pipId} className="loading-indicator" />
        );
    },
});

export default LoadingPip;


/** WEBPACK FOOTER **
 ** ./src/components/Fragments/LoadingPip.js
 **/